<template>
  <div id="app" class="min-h-screen bg-slate-950 text-slate-300 font-sans selection:bg-indigo-500/30 selection:text-indigo-200">
    <!-- Offline Banner -->
    <OfflineBanner />
    
    <!-- Admin Navigation (Only shown on authenticated admin pages) -->
    <AppNavbar v-if="route.meta.requiresAdmin" />
    
    <!-- Main Content -->
    <main :class="route.meta.requiresAdmin ? 'min-h-[calc(100vh-64px)]' : 'min-h-screen'">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    
    <!-- Footer (Only shown on admin pages) -->
    <AppFooter v-if="route.meta.requiresAdmin" />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useOfflineStore } from '@/stores/offlineStore'
import OfflineBanner from '@/components/OfflineBanner.vue'
import AppNavbar from '@/components/AppNavbar.vue'
import AppFooter from '@/components/AppFooter.vue'

const route = useRoute()
const offlineStore = useOfflineStore()

onMounted(() => {
  offlineStore.initialize()
})
</script>

<style>
/* Global Transitions & Overrides */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Base custom scrollbar */
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: #0f172a; /* slate-900 */
}
::-webkit-scrollbar-thumb {
  background: #334155; /* slate-700 */
  border-radius: 5px;
  border: 2px solid #0f172a;
}
::-webkit-scrollbar-thumb:hover {
  background: #475569; /* slate-600 */
}
</style>
